module.exports = __webpack_public_path__ + "img/Leads.8113d33d.svg";